import { createContext, useState, useContext } from "react";

const DialogContext = createContext();
export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    isOpen: false,
    isInputOpen: false,
    isAiOptions: false,
    isMediaOpen: false,
    isRcs: false,
    selection: "single",
    selectionLimit: 1,
    type: "simple", // 'success', 'fail', 'simple'
    subtype: "info", // 'delete' (only for simple type)
    isInputType: "",
    inputLabel: "",
    title: "",
    message: "",
    mediaType: "image",
    buttonText: "OK",
    buttonLabel: undefined,
    onConfirm: null,
    disableBackdropClick: false,
    disableEscapeKeyDown: false,
  });

  const showDialog = (title, message, options = {}) => {
    setDialog({
      isOpen: true,
      title,
      message,
      ...options,
    });
  };
  const hideDialog = () => {
    setDialog((prev) => ({ ...prev, isOpen: false }));
  };
  const showInputDialog = (title, message, options = {}) => {
    setDialog({
      isInputOpen: true,
      title,
      message,
      ...options,
    });
  };
  const hideInputDialog = () => {
    setDialog((prev) => ({ ...prev, isInputOpen: false }));
  };
  const showAiDialog = (title, message, options = {}) => {
    setDialog({
      isAiOptions: true,
      title,
      message,
      ...options,
    });
  };
  const hideAiDialog = () => {
    setDialog((prev) => ({ ...prev, isAiOptions: false }));
  };
  const showMediaDialog = (title, message, options = {}) => {
    setDialog({
      isMediaOpen: true,
      title,
      message,
      ...options,
    });
  };
  const hideMediaDialog = () => {
    setDialog((prev) => ({ ...prev, isMediaOpen: false }));
  };

  return (
    <DialogContext.Provider
      value={{
        dialog,
        showDialog,
        hideDialog,
        showInputDialog,
        hideInputDialog,
        showAiDialog,
        hideAiDialog,
        showMediaDialog,
        hideMediaDialog,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};
export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("Dialog must be used within a DialogProvider");
  }
  return context;
};
